export function calculateGridHeight(gridId) {
  var grid = document.getElementById(gridId);
  if (null == grid)
    return 0;
  var containerOffset = offset(document.getElementsByClassName("content")[0]);
  return Math.max(window.innerHeight - containerOffset.top - document.getElementById(gridId).offsetTop, 50) - 25;
}

function offset(element) {
  var rect = element.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft, height: rect.height, width: rect.width }
}

export function setAgeCellClass(age) {
  if (age >= 60) {
    return "ageStyle60Plus";
  }
  else if (age >= 46 && age < 60) {
    return "ageStyle46to60";
  }
  else if (age >= 31 && age <= 45) {
    return "ageStyle31to45";
  }
  else {
    return "";
  }
}

// `setTitleClass` used to live here. It returned the green ".staging-env" class when the
// runtime `window.env.REACT_APP_IS_STAGING` was set, and "content-block" otherwise, so every
// page heading turned green on staging. Both it and the style are gone: environments are now
// distinguished by VITE_APP_NAME (see src/config.js), which is shown in the app header and
// the browser tab, and the headings use "content-block" directly.